import { useState } from 'react';
import '../styles/Home.css';
function Home({ setCurrentPage }) {
  const [expandedItem, setExpandedItem] = useState(0);

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 102, 204, 0.5), rgba(0, 68, 153, 0.5)), url('${process.env.PUBLIC_URL}/images/hero.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#ffffff',
    width: '100%',
    boxSizing: 'border-box'
  };

  const buttonStyle = {
    background: '#0f75bd',
    color: '#ffffff',
    padding: '16px 50px',
    fontSize: '16px',
    fontWeight: '700',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.4s ease',
    boxShadow: '0 6px 20px rgba(15, 117, 189, 0.5)',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    marginTop: '4px'
  };

  const accordionItems = [
    { title: '01. We create Solutions', desc: 'We accept that the center of our prosperity lies in our special compassionate way to deal with critical thinking.' },
    { title: '02. We know your business', desc: 'At Neoprism, we take absolute attention to detail to cultivate a positive work environment culture that guarantees a blissful group.' },
    { title: '03. We deliver results', desc: 'We focus on measurable outcomes and continuous improvement for your organization.' }
  ];

  const serviceItems = [
    {
      title: 'Cloud & Infrastructure',
      desc: 'Supercharge your software releases by delivering new product features at scale to drive the next best experience for each customer',
      image: '/images/cloud1.png',
      imageLeft: true
    },
    {
      title: 'AI, Data & Analytics',
      desc: 'Empower your data to gain competitive advantage, improve operational efficiency, enhance customer experience, & drive innovation',
      image: '/images/ai1.png',
      imageLeft: false
    },
    {
      title: 'Cyber Security',
      desc: 'Protect your business\' digital assets and systems from cyber threats to ensure the utmost confidentiality of information',
      image: '/images/cyber1.png',
      imageLeft: true
    },
    {
      title: 'Devops & Automation',
      desc: 'Streamline your IT infrastructure and automate your CI/CD pipelines with our proprietary DevOps accelerators and framework',
      image: '/images/devops1.png',
      imageLeft: false
    }
  ];

  return (
    <div className="home">
      <section className="hero" style={heroStyle}>
        <h1 style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.7)' }}>Delivering Next-Gen Experiences Through Custom Tech Innovations</h1>
        <p style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.7)', maxWidth: '700px', lineHeight: '1.8' }}>Powering businesses across the globe with our deep IT consulting and services expertise in modern technology, we bring the industry's best practices to deliver quality business outcomes.</p>
        <button 
          onClick={() => setCurrentPage('Contact')}
          style={buttonStyle}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-3px)';
            e.target.style.boxShadow = '0 10px 30px rgba(15, 117, 189, 0.65)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 6px 20px rgba(0, 102, 204, 0.5)';
          }}
        >
          Learn More →
        </button>
      </section>

      <section className="supplier-section">
        <div className="supplier-wrapper">
        <div className="supplier-images-side">
  <img src="/images/h1.png" alt="Team 1" className="supplier-img-1" />
  <img src="/images/h2.png" alt="Team 2" className="supplier-img-2" />
  <img src="/images/h3.png" alt="Team 3" className="supplier-img-3" />
</div>
          <div className="supplier-content-side">
            <h2>We are a main supplier of coordinated business arrangements</h2>
            <p>Our answers influence industry mastery and driving edge advancements to tackle business issues, all around the world, each and every day. Our worldwide conveyance model includes nearby counseling and conveyance, off-site and seaward conveyance connecting time and geological holes, guaranteeing our client, gets the best incentive for cash and time.</p>
            
            <div className="accordion">
              {accordionItems.map((item, index) => (
                <div key={index} className="accordion-item">
                  <button 
                    className="accordion-header"
                    onClick={() => setExpandedItem(expandedItem === index ? -1 : index)}
                  >
                    <span>{item.title}</span>
                    <span className="accordion-icon">
                      {expandedItem === index ? '−' : '+'}
                    </span>
                  </button>
                  {expandedItem === index && (
                    <div className="accordion-content">
                      <p>{item.desc}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
{/* Services Section */}
<section className="services-section">
  <h2 className="services-title">Providing Flawless Service For You !</h2>
  
  <div className="services-grid">
    {/* Service 1 */}
    <div className="service-item">
      <div className="service-text">
        <h3>Cloud & Infrastructure</h3>
        <p>Supercharge your software releases by delivering new product features at scale to drive the next best experience for each customer</p>
      </div>
      <img src="/images/cloud1.png" alt="Cloud & Infrastructure" />
    </div>

    {/* Service 2 */}
    <div className="service-item">
      <div className="service-text">
        <h3>AI, Data & Analytics</h3>
        <p>Empower your data to gain competitive advantage, improve operational efficiency, enhance customer experience, & drive innovation</p>
      </div>
      <img src="/images/cyber1.png" alt="AI, Data & Analytics" />
    </div>

    {/* Service 3 */}
    <div className="service-item">
      <div className="service-text">
        <h3>Cyber Security</h3>
        <p>Protect your business' digital assets and systems from cyber threats to ensure the utmost confidentiality of information</p>
      </div>
      <img src="/images/cyber1.png" alt="Cyber Security" />
    </div>

    {/* Service 4 */}
    <div className="service-item">
      <div className="service-text">
        <h3>DevOps & Automation</h3>
        <p>Streamline your IT infrastructure and automate your CI/CD pipelines with our proprietary DevOps accelerators and framework</p>
      </div>
      <img src="/images/dataanalytics1.png" alt="DevOps & Automation" />
    </div>

    {/* Service 5 */}
    <div className="service-item">
      <div className="service-text">
        <h3>Digital Engineering</h3>
        <p>Leverage advanced DE technologies & engineering best practices to design, develop, and deliver innovative digital solutions</p>
      </div>
      <img src="/images/devops1.png" alt="Digital Engineering" />
    </div>

    {/* Service 6 */}
    <div className="service-item">
      <div className="service-text">
        <h3>Technology Consulting</h3>
        <p>Get our expert technology consulting advice, guidance, and support for your organization and achieve business objectives</p>
      </div>
      <img src="/images/techno1.png" alt="Technology Consulting" />
    </div>
  </div>
</section>
      
                
            </div>
          )}
        
      
    
  


export default Home;